const types = [
    { id: 0, name: 'None' },
    { id: 1, name: 'Actual' },
    { id: 2, name: 'Used' },
];

export default types;
